"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardRequirementComponent_vue_1 = __importDefault(require("./CardRequirementComponent.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'CardRequirementsComponent',
    props: {
        requirements: {
            type: Array,
            required: true,
        },
    },
    components: {
        'card-requirement': CardRequirementComponent_vue_1.default,
    },
    computed: {
        getClasses() {
            const hasMax = this.requirements.some((req) => req.max);
            return hasMax ? 'card-requirements card-requirements-max' : 'card-requirements';
        },
        indentRight() {
            return [false, ...this.requirements.map((req) => (req.nextTo || false))];
        },
    },
});
